import React from 'react';
import { Box, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import { colors } from '../../../theme';

interface TrustIndicatorsProps {
  items: string[];
  marginBottom?: string;
}

export const TrustIndicators: React.FC<TrustIndicatorsProps> = ({ items, marginBottom = '48px' }) => {
  return (
    <Typography
      sx={{
        fontSize: '0.875rem',
        color: colors.slate[500],
        marginBottom,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '8px',
      }}
    >
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Check sx={{ fontSize: '14px', color: colors.success }} />
            {item}
          </Box>
          {index < items.length - 1 && <Box component="span">·</Box>}
        </React.Fragment>
      ))}
    </Typography>
  );
};
